import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const NewsBlock = ({ data, index }) => {
    const navigate = useNavigate();
    const defaultImage = "/images/error-image.png";

    const getTextPreview = (html, limit) => {
        if (!html) return "";
        const plainText = html.replace(/<[^>]*>/g, '');
        return plainText.length > limit
            ? `${plainText.substring(0, limit)}...`
            : plainText;
    };

    const handleImageError = useCallback((event) => {
        event.target.src = defaultImage;
    }, []);
    return (
        <div className="news-block">
            <div className="inner-box" style={{ height: index === "homePage" ? "750px" : "800px" }}>
                <div className="image">
                    <a>
                        <img
                            src={data?.imageUrl || defaultImage}
                            onError={handleImageError}
                            alt="img"
                            style={{ width: "100%", height: index === "homePage" ? "300px" : "500px", objectFit: 'cover' }}
                        />
                    </a>
                </div>
                <div className="lower-content">
                    <div className="post-date">
                        {data?.publishedDate ? new Date(data.publishedDate).toLocaleDateString() : ""}
                    </div>
                    <div className="author-box">
                        <div className="content">
                            <strong>{data?.title}</strong>
                            <span className="designation">{data?.tag}</span>
                        </div>
                    </div>
                    <div className="lower-box">
                        <h5><a onClick={() => navigate(`/blog-details/${data?.id}`)} className='text-red'>{data?.title}</a></h5>     


                        <div className="text">
                            {getTextPreview(data?.content, 35)}
                        </div>

                        <a className="read-more" onClick={() => navigate(`/blog-details/${data?.id}`)}>Read Article</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewsBlock;